import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../store/Index";

interface RequireAdminGroupProps {
  children: React.ReactNode;
}

/**
 * Mirrors the backend's authentication.views.PermissionListView gate
 * (superuser or membership in the "Admin" group) for pages that depend on
 * the full permission catalogue endpoint, which isn't covered by any
 * Django model permission.
 */
const RequireAdminGroup: React.FC<RequireAdminGroupProps> = ({ children }) => {
  const authUser = useSelector((state: RootState) => state.auth.user);
  const isAdmin =
    String(authUser?.is_supper_user) === "true" ||
    !!authUser?.group_names?.includes("Admin");

  if (!isAdmin) {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
};

export default RequireAdminGroup;
